import styled from 'styled-components';
import { toRem } from '@marriott/mi-ui-library';

export const StyledIntroText = styled.section`
  .intro-text-content {
    display: flex;
    flex-direction: column;
    row-gap: ${toRem(16)};
  }

  .intro-text-body {
    font-weight: 400;
  }

  .intro-text-body p {
    margin-bottom: 0;
  }
`;
